import * as types from "../constants/actionConstants";

const initialState = {
    versions: [],
    templateKey: ""
};

function questionnaireVersionReducer(state = initialState, action) {
    switch (action.type) {
        case types.QUESTIONNAIRE_VERSIONS_GET_SUCCESS:
            return {
                versions: action.versions,
                templateKey: action.templateKey
            };
        case types.QUESTIONNAIRE_VERSIONS_CLEAR:
            return initialState;
        default:
            return state;
    }
}

export default questionnaireVersionReducer;